<template>
  <div
    :class="{
      'diagnosis-item-wrap': true,
      'diagnosis-item-wrap-hor': direction === 'horizontal',
    }"
  >
    <!-- 标题 -->
    <div @click="closeToolTip">
      <Title v-if="direction === 'vertical'" :data="data" />
    </div>
    <div v-if="tagData[data.chartkey]" class="chart-mode-choose">
      <div
        v-for="(item, index) in tagData[data.chartkey]"
        :key="index"
        :class="{ 'mode-tag': true, 'mode-selected': index === currentMode }"
        @click="chooseMode(index)"
      >
        <p>{{ item.name }}</p>
      </div>
    </div>
    <!-- 指标 -->
    <div @click="closeToolTip">
      <Indicators
        :key="currentMode"
        :data="getIndicators"
        :direction="direction"
        :show-compare-info="showCompareInfo"
      />
    </div>
    <!-- top10菜品 -->
    <TopItems v-if="data.chartkey === 'menu'" :item-data="data.itemTop10" :period="period" />
    <div v-if="data.chartkey === 'usersAndConversion'" class="chart-mode-choose">
      <div
        v-for="(item, index) in funnelData"
        :key="index"
        :class="{ 'mode-tag': true, 'mode-selected': index === currentMode }"
        @click="chooseMode(index)"
      >
        <p>{{ item.name }}</p>
      </div>
    </div>
    <!-- 用户及转化漏斗图 -->
    <FunnelChart
      v-if="data.chartkey === 'usersAndConversion' && currentMode === 0"
      :item-data="data.funnelData"
    ></FunnelChart>
    <!-- 图表 -->
    <charts
      v-if="
        data.chartData &&
        (data.chartkey !== 'usersAndConversion' ? true : currentMode === 0 ? false : true)
      "
      ref="charts"
      :options="data.chartData"
      :height="data.chartHeight"
      :direction="direction"
      :chartkey="data.chartkey"
      @showHorCharts="showHorCharts"
    />
  </div>
</template>

<script>
import Title from './title/index.vue'
import TopItems from './TopItems/index.vue'
import FunnelChart from './FunnelChart/index.vue'
import Indicators from './Indicators/index.vue'
import charts from '../charts/index.vue'
import { chartKeyForHorShow } from './../../utils/builder.js'
import EventBus from './../../utils/eventBus'

export default {
  components: {
    // eslint-disable-next-line vue/no-reserved-component-names
    Title,
    Indicators,
    charts,
    TopItems,
    FunnelChart,
  },
  props: {
    data: {
      type: Object,
      default: () => ({}),
    },
    direction: {
      type: String,
      default: 'vertical',
    },
    showCompareInfo: {
      type: Boolean,
      default: false,
    },
    period: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      currentMode: 0,
      funnelData: [
        {
          name: this.$t('FoodB_20250414_WmJY_oZbB' /** 漏斗 */),
        },
        {
          name: this.$t('FoodB_20250414_qQjO_NTiY' /** 时间线 */),
        },
      ],
      tagData: {
        completeOrder: [
          {
            name: this.$t('FoodB_APP_YjyK_hqYn' /** 订单 */),
          },
          {
            name: this.$t('FoodB_APP_PJrW_uBye' /** AOP/ASP */),
          },
        ],
        service: [
          {
            name: this.$t('Gattaran_opt_QCLu_UWmJ' /** 取消订单 */),
          },
          {
            name: this.$t('Gattaran_opt_cWad_xQOF' /** 问题订单 */),
          },
        ],
      },
    }
  },
  computed: {
    getIndicators() {
      if (this.data.chartkey === 'completeOrder') {
        if (this.currentMode === 0) {
          // 订单order展示完单量、日均完单量
          return this.data.indicators.filter(
            ele => ele.key === 'completeOrderCntD30' || ele.key === 'dailyOrders',
          )
        } else {
          // AOP/ASP展示AOP、ASP
          return this.data.indicators.filter(ele => ele.key === 'aop' || ele.key === 'asp')
        }
      } else if (this.data.chartkey === 'service') {
        if (this.currentMode === 0) {
          // 已取消的订单展示取消率、损失营业额、取消订单量
          return this.data.indicators.filter(
            ele =>
              ele.key === 'cancellationRatio' ||
              ele.key === 'lostSales' ||
              ele.key === 'cancelOrderCnt',
          )
        } else {
          // 问题订单展示问题订单率、问题订单量
          return this.data.indicators.filter(
            ele => ele.key === 'imperfectOrderRatio' || ele.key === 'imperfectOrderCnt',
          )
        }
      }
      return this.data.indicators
    },
  },
  methods: {
    chooseMode(index) {
      if (this.currentMode !== index) {
        this.currentMode = index
        this.$refs.charts?.setCurrentMode(index)
      }
    },
    // 用于通知图表点击了其他区域，隐藏图表的tooltip
    closeToolTip() {
      EventBus.$emit('handleToolTipClose', '')
    },
    showHorCharts(key) {
      const chartKey = chartKeyForHorShow.indexOf(key)
      this.$emit('showHorChartsItem', chartKey)
    },
  },
}
</script>
<style lang="scss" scoped>
.diagnosis-item-wrap {
  position: relative;
  padding: 24px;
  margin-top: 24px;
  border-radius: 8px;
  background: #ffffff;
  overflow: hidden;

  .tips {
    position: relative;
    display: flex;
    margin-top: 24px;
    align-items: flex-start;
    line-height: 28px;
    margin-bottom: 12px;

    i {
      width: 24px;
      height: 24px;
      line-height: 24px;
      color: #8d9099;
      margin-right: 4px;
      font-size: 20px;
    }

    span {
      line-height: 24px;
      font-family: PingFangSC-Regular;
      font-size: 20px;
      color: #8d9099;
      font-weight: 400;
      flex: 1;
    }
  }

  .action-container {
    position: relative;
    margin-top: 24px;
    background-image: linear-gradient(180deg, #fff8f3 0%, #ffffff 100%);
    padding: 16px 24px 8px;
    .action-title {
      font-family: DiDiSans-Pro-Bold;
      font-size: 24px;
      color: #f76a31;
      line-height: 36px;
      font-weight: 600;
    }

    .action-wrap {
      position: relative;
      .action-item {
        position: relative;
        display: flex;
        align-items: flex-start;
        margin-top: 16px;
        margin-bottom: 24px;
        i {
          display: block;
          width: 16px;
          height: 16px;
          opacity: 0.5;
          border: 3px solid #f76a31;
          margin-right: 16px;
          box-sizing: border-box;
          border-radius: 16px;
          margin-top: 8px;
        }

        p {
          flex: 1;
          font-family: PingFangSC-Regular;
          font-size: 24px;
          color: #595c66;
          line-height: 32px;
          font-weight: 400;
        }
      }
    }
  }
}
.diagnosis-item-wrap-hor {
  margin-top: 0px;
}
.chart-mode-choose {
  display: flex;
  margin: 40px 0 40px 0;
  .mode-tag {
    height: 32px;
    background: #f0f1f5;
    border-radius: 12px;
    padding: 8px 16px;
    margin-right: 24px;
    font-size: 24px;
    p {
      line-height: 32px;
      color: #595c66;
    }
  }
  .mode-selected {
    background: #ffefe7;
    p {
      color: #f76a31;
    }
  }
}
</style>
